import { render, staticRenderFns } from "./jj-prum.vue?vue&type=template&id=41c7bb90&scoped=true"
import script from "./jj-prum.vue?vue&type=script&lang=js"
export * from "./jj-prum.vue?vue&type=script&lang=js"
import style0 from "./jj-prum.vue?vue&type=style&index=0&id=41c7bb90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c7bb90",
  null
  
)

export default component.exports